const MO_FR = 'Mo-Fr '

/**
 * Convert a time-range string like "09:00-13:00" into the UI display
 * form "09:00 - 13:00". Splitting on '-' is safe because the time
 * tokens themselves use ':' as separator, so the hyphen is unique.
 *
 * Returns null when either side is missing.
 */
export const toUiRange = (raw: string): string | null => {
  const [from, to] = raw.split('-')
  return from && to ? `${from} - ${to}` : null
}

/**
 * Returns true when any two `Mo-Fr` intervals in the schedule overlap
 * or touch (afternoon.from === morning.to is treated as overlap).
 *
 * Saturday entries are ignored — they never compete with weekdays for
 * the same slot. Malformed entries that don't start with `Mo-Fr ` are
 * skipped silently.
 */
export const hasWeekdayOverlap = (openingHours: string[] | undefined): boolean => {
  if (!openingHours || openingHours.length < 2) return false
  const slots = openingHours.filter(s => s.startsWith(MO_FR)).map(s => s.slice(MO_FR.length).split('-'))
  if (slots.length < 2) return false
  const sorted = [...slots].sort((a, b) => a[0].localeCompare(b[0]))
  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i][0] <= sorted[i - 1][1]) return true
  }
  return false
}
